import { useState } from "react";
import { Link } from "react-router-dom";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Menu, Home, Grid, Settings, DollarSign, Mail, LogIn, UserPlus, ShoppingBag } from "lucide-react";
import { useAuthActions } from "@/hooks/useAuthActions";
import { useProfile } from "@/hooks/useProfile";

const MobileNav = () => {
  const [open, setOpen] = useState(false);
  const { handleLogout } = useAuthActions();
  const { profile } = useProfile();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          className="mr-2 px-0 text-base hover:bg-transparent focus-visible:bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0 md:hidden"
        >
          <Menu className="h-6 w-6" />
          <span className="sr-only">Toggle Menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="pr-0">
        <nav className="flex flex-col space-y-4">
          <Link
            to="/"
            className="text-sm font-medium flex items-center gap-2"
            onClick={() => setOpen(false)}
          >
            <Home className="h-4 w-4" />
            Home
          </Link>
          <Link
            to="/dashboard"
            className="text-sm font-medium flex items-center gap-2"
            onClick={() => setOpen(false)}
          >
            <Grid className="h-4 w-4" />
            Dashboard
          </Link>
          <Link
            to="/marketplace"
            className="text-sm font-medium flex items-center gap-2"
            onClick={() => setOpen(false)}
          >
            <ShoppingBag className="h-4 w-4" />
            Marketplace
          </Link>
          <Link
            to="/services"
            className="text-sm font-medium flex items-center gap-2"
            onClick={() => setOpen(false)}
          >
            <Settings className="h-4 w-4" />
            Services
          </Link>
          <Link
            to="/prices"
            className="text-sm font-medium flex items-center gap-2"
            onClick={() => setOpen(false)}
          >
            <DollarSign className="h-4 w-4" />
            Prices
          </Link>
          <Link
            to="/contact"
            className="text-sm font-medium flex items-center gap-2"
            onClick={() => setOpen(false)}
          >
            <Mail className="h-4 w-4" />
            Contact
          </Link>
          {profile ? (
            <Button
              variant="ghost"
              className="justify-start px-2"
              onClick={() => {
                handleLogout();
                setOpen(false);
              }}
            >
              Logout
            </Button>
          ) : (
            <>
              <Link
                to="/auth"
                className="text-sm font-medium flex items-center gap-2"
                onClick={() => setOpen(false)}
              >
                <LogIn className="h-4 w-4" />
                Login
              </Link>
              <Link
                to="/auth?mode=register"
                className="text-sm font-medium flex items-center gap-2"
                onClick={() => setOpen(false)}
              >
                <UserPlus className="h-4 w-4" />
                Register
              </Link>
            </>
          )}
        </nav>
      </SheetContent>
    </Sheet>
  );
};

export default MobileNav;